import React, { useState,useEffect } from 'react';
import axios from 'axios'
import CommonVars from '../Component/CommonVars';
import { useParams } from 'react-router-dom';
import { Box,Flex,Image,VStack, chakra ,Heading  } from '@chakra-ui/react';



function ProductsByCat() {
    const [products,setProducts] = useState('')
    useEffect(() =>{
    getProductsByCat()
    },[])

    const categoryId = useParams().categoryid

    const getProductsByCat = async() =>{
        axios.get(`${CommonVars.API_URL}/products/category/${categoryId}`)
        .then((res) =>{
            const Productsdata = res.data;
            console.log(res)
            console.log(Productsdata);
            setProducts(Productsdata);
        }).catch((err) =>{
            console.log(err)
        })
    }

    const aProductsbyCat = []
    for(var i =0 ; i<products.length;i++){
        aProductsbyCat.push(
            <chakra.a href={`/products/${products[i].productid}`}>
                    
                        <Box
                        mb={'20px'}
                        shadow={'lg'}
                            p={10}
                            // width={"40%"}
                        >
                            <Image 
                                src={products[i].image}
                                boxSize={"280px"}
                                // mx={"auto"}
                            />
                            <Box>
                                {products[i].name}
                            </Box>
                            <Box>
                                {products[i].price}  
                            </Box>
                        </Box>
              </chakra.a>
        )
    }
   
    return(
        <Box p={50}>
        <Flex direction={"row"} flexWrap={"wrap"} justifyContent={"space-around"}>
            {aProductsbyCat}
        </Flex>
    </Box>
 
    )
   
}

export default ProductsByCat;